export default {
  title: 'Ueberschneidendes Angebot im selben Zeitraum',
  buttons: {
    save_as_active: 'Als neues aktives Angebot setzen',
    save_as_inactive: 'Als inaktiv speichern',
    cancel: 'Abbrechen',
  },
  description: {
    base: '{{offer}} ueberschneidet sich mit dem aktiven Angebot {{overlappingOffer}} am {{weekday}}{{between}}. Es kann nur ein Angebot im selben Zeitraum aktiv sein.',
    between: ', zwischen {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Loesung: Waehlen Sie eine der folgenden Optionen.',
  },
};
